import { render, staticRenderFns } from "./DepartmentUserList.vue?vue&type=template&id=073477e7&scoped=true&"
import script from "./DepartmentUserList.vue?vue&type=script&lang=js&"
export * from "./DepartmentUserList.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentUserList.vue?vue&type=style&index=0&id=073477e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073477e7",
  null
  
)

export default component.exports